import { IAccessGrantedPayload } from "../../../model/respone/queue/IAccessGrantedPayload";
import { IQueuePositionPayload } from "../../../model/respone/queue/IQueuePositionPayload";
import { IQueueStatus } from "../../../model/respone/queue/IQueueStatus";
import { IQueueTickPayload } from "../../../model/respone/queue/IQueueTickPayload";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eQueueActionTypeDefine = {
    LOAD_STATUS_START: undefined as undefined,
    LOAD_STATUS_SUCCESS: {} as IQueueStatus,
    LOAD_STATUS_ERROR: "" as string,

    SET_POSITION: {} as IQueuePositionPayload,
    TICK: {} as IQueueTickPayload,
    ACCESS_GRANTED: {} as IAccessGrantedPayload,
    PERIOD_CLOSED: undefined as undefined,
    PERIOD_OPENED: undefined as undefined,
    RESET: undefined as undefined,
};

export const eQueueActionTypeIds = generateActionTypeIds(eQueueActionTypeDefine, "QUEUE");

export type IQueueActions = IGenericActionType<typeof eQueueActionTypeDefine, "QUEUE">;
